"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCurrentLocation = void 0;
var _react = require("react");
var _models = require("../models");
const useCurrentLocation = props => {
  const {
    isActive,
    onError,
    onSuccess
  } = props;
  const [currentLocation, setCurrentLocation] = (0, _react.useState)();
  const [currentLocationStatus, setCurrentLocationStatus] = (0, _react.useState)(_models.CurrentLocationStatus.Waiting);
  (0, _react.useEffect)(() => {
    if (!isActive || !window.isSecureContext || currentLocationStatus !== _models.CurrentLocationStatus.Waiting) {
      return;
    }
    navigator.geolocation.getCurrentPosition(position => {
      setCurrentLocationStatus(_models.CurrentLocationStatus.Success);
      const {
        latitude,
        longitude
      } = position.coords;
      setCurrentLocation({
        latitude,
        longitude
      });
      onSuccess?.({
        latitude,
        longitude
      });
    }, error => {
      setCurrentLocationStatus(_models.CurrentLocationStatus.Error);
      onError?.(error);
    });
  }, [isActive, currentLocationStatus, onError, onSuccess, setCurrentLocationStatus]);
  return {
    currentLocation,
    currentLocationStatus
  };
};
exports.useCurrentLocation = useCurrentLocation;